import { render, staticRenderFns } from "./qs1-08.vue?vue&type=template&id=683dc3fa&scoped=true&"
import script from "./qs1-08.vue?vue&type=script&lang=js&"
export * from "./qs1-08.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683dc3fa",
  null
  
)

export default component.exports